import { render } from "./StockReport.vue?vue&type=template&id=3dbf0f4c&scoped=true"
import script from "./StockReport.vue?vue&type=script&lang=js"
export * from "./StockReport.vue?vue&type=script&lang=js"

import "./StockReport.vue?vue&type=style&index=0&id=3dbf0f4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dbf0f4c"]])

export default __exports__